import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, CanActivate, CanActivateChild } from "@angular/router";
import { Observable } from "rxjs";
import { AuthService } from "../../service";

@Injectable({
    providedIn: "root",
})
export class AuthGuard implements CanActivateChild, CanActivate {
    constructor(private readonly authService: AuthService) {}

    canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const authenticate = !!this.authService.token;
    return authenticate;
    }
    canActivateChild(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.authService.checkAuth(state);
    }
}
